import { useCallback, useEffect, useRef, type ReactNode } from 'react';

import { getConfiguracaoAtual } from '@/lib/secretario/configuracaoAtual';

import { useWizardSave, WizardSaveProvider, type RegisterFlush } from './WizardSaveContext';

/**
 * Uma subpágina do passo Advogados (o perfil de um advogado, o padrão do escritório):
 * os cartões dela registram o que falta salvar aqui E no wizard, e sair dela — o
 * "← Advogados" ou o voltar do navegador — salva antes de desmontá-los. Sem isso, o
 * que estava digitado se perdia: a subpágina sai sem passar pela troca de passo, que
 * é onde o wizard salva.
 */
export function SalvaAoSair({ configuracaoId, children }: { configuracaoId: string; children: ReactNode }) {
  const doWizard = useWizardSave();
  const pendentes = useRef(new Map<string, () => void>());
  const registrar = useCallback<RegisterFlush>(
    (chave, flush) => {
      if (flush) pendentes.current.set(chave, flush);
      else pendentes.current.delete(chave);
      doWizard(chave, flush);
    },
    [doWizard],
  );
  // Na desmontagem, o efeito do pai é desfeito antes dos filhos: os cartões ainda
  // estão registrados quando isto roda. Saiu porque outro secretário foi escolhido? As
  // chamadas já iriam para o outro (``comConfig`` lê a escolha na hora): não salva.
  useEffect(() => {
    const mapa = pendentes.current;
    return () => {
      // Sem escolha guardada, a chamada vai ao único que existe — que é este.
      const atual = getConfiguracaoAtual();
      if (atual === null || atual === configuracaoId) mapa.forEach((flush) => flush());
      mapa.clear();
    };
  }, [configuracaoId]);
  return <WizardSaveProvider value={registrar}>{children}</WizardSaveProvider>;
}
